import { PatientScheduleResponse, PermissionBit } from "../../api";
import { DataModel } from "../../models/data-model";

export class Schedules extends DataModel<PatientScheduleResponse> {
  constructor(
    data: PatientScheduleResponse[],
    permissions: PermissionBit[],
    userUUID: string,
  ) {
    super(data, permissions, userUUID);
  }
}
